import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxProfileReviewInfo } from '../fragments';

export default gql`
  mutation ActionTaxProfileReviewStatus(
    $input: TaxProfileReviewStatusActionInput!
  ) {
    actionTaxProfileReviewStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfileReview {
        ...TaxProfileReviewInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxProfileReviewInfo}
`;
